import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26a9edc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-container" }
const _hoisted_2 = { class: "primary-date-row" }
const _hoisted_3 = { class: "secondary-date-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.dateFormat(_ctx.startDate)), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.startEndTime), 1)
  ]))
}